import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { SchoolAcademicYearResponse } from '../models/school-academic-year-response';

@Injectable({
  providedIn: 'root',
})
export class AcademicYearService {
  apiService = inject(ApiService);

  getSchoolsAcademicYears(schoolIds: string[]) {
    const url = 'api/Schools/AcademicYears/GetCurrent';
    return this.apiService.invokeLSApi<SchoolAcademicYearResponse[]>(
      url,
      HttpAction.PostWithBodyResponse,
      schoolIds
    );
  }
}
